let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9yF73")).then(() => parcelRequire('cMOoZ'));